import { render, staticRenderFns } from "./HumanInTheLoop.vue?vue&type=template&id=895e84ec"
import script from "./HumanInTheLoop.vue?vue&type=script&lang=js"
export * from "./HumanInTheLoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports